import { jsx as c } from "react/jsx-runtime";
import k from "clsx";
import { Link as z } from "react-router";
const o = (e) => k(e), b = "dds-link-v0132", $ = (e) => !!e.onClick, v = (e) => !!e.href && e.href.length > 0, p = (e) => !!e.to && e.to.length > 0;
function C(e) {
  const { className: y = "", size: L = "medium", type: h = "standalone" } = e, N = $(e), d = {
    [b]: !0,
    [`${b}--button`]: N,
    [`${b}--inverse`]: e.inverse ?? !1,
    [`${b}--${L}`]: !0,
    [`${b}--${h}`]: !0,
    [y]: y.length > 0
  };
  if (p(e)) {
    const {
      children: a,
      to: i,
      disabled: s = !1,
      ariaLabel: l,
      ariaLabelledby: t,
      ariaDescribedby: r,
      // We do this here so we don't overwrite the values of the same name from the ...rest param
      size: u,
      type: m,
      className: f,
      ...n
    } = e;
    return /* @__PURE__ */ c(
      z,
      {
        "aria-disabled": s ? "true" : void 0,
        "aria-label": l,
        "aria-labelledby": t,
        "aria-describedby": r,
        to: i,
        className: o(d),
        ...n,
        children: a
      }
    );
  }
  if (N) {
    const {
      children: a,
      disabled: i = !1,
      onClick: s,
      ariaLabel: l,
      ariaLabelledby: t,
      ariaDescribedby: r,
      // We do this here so we don't overwrite the values of the same name from the ...rest param
      size: u,
      type: m,
      className: f,
      ...n
    } = e;
    return /* @__PURE__ */ c(
      "button",
      {
        "aria-disabled": i ? "true" : void 0,
        "aria-label": l,
        "aria-labelledby": t,
        "aria-describedby": r,
        onClick: s,
        className: o(d),
        type: "button",
        ...n,
        children: a
      }
    );
  }
  if (v(e)) {
    const {
      children: a,
      href: i,
      disabled: s = !1,
      ariaLabel: l,
      ariaLabelledby: t,
      ariaDescribedby: r,
      // We do this here so we don't overwrite the values of the same name from the ...rest param
      size: u,
      type: m,
      className: f,
      ...n
    } = e;
    return /* @__PURE__ */ c(
      "a",
      {
        "aria-disabled": s ? "true" : void 0,
        "aria-label": l,
        "aria-labelledby": t,
        "aria-describedby": r,
        href: i,
        className: o(d),
        ...n,
        children: a
      }
    );
  }
  return null;
}
export {
  C as Link
};
//# sourceMappingURL=index.js.map
